<div class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center">
  <!-- Modal con dimensioni standard più piccole, ma grandi su 2xl -->
  <div class="bg-white/95 w-[600px] max-w-md 2xl:max-w-none mx-4 py-3 pl-4 pr-6 2xl:py-4 2xl:pl-5 2xl:pr-8 max-h-[80vh] 2xl:max-h-[85vh] rounded-md shadow-lg space-y-3 2xl:space-y-4 overflow-y-auto 2xl:overflow-y-hidden relative text-xs 2xl:text-sm">
  
    <!-- Header -->
    <div class="mb-4 2xl:mb-6">
      <h1 class="text-base 2xl:text-lg mb-1.5 2xl:mb-2 mt-0.5 2xl:mt-1 text-dimot-1">Modifica il tuo profilo</h1>
      <div class="text-gray-600 text-[0.82rem] 2xl:text-xs leading-snug">
        <span class="inline">Non condivideremo mai i tuoi dati. Consulta la nostra</span>
        <h4 class="inline font-bold ml-1">Informativa sulla privacy.</h4>
      </div>
    </div>
  
    <!-- Full name section -->
    <div class="flex flex-col gap-0.5 2xl:gap-1">
      <span class="text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Nome completo</span>
      <div class="space-y-2 2xl:space-y-3">
        <input 
          type="text"
          class="w-full pl-2 p-1 2xl:p-1.5 border rounded-md focus:ring-1 focus:ring-gray-300 focus:border-gray-300 text-xs 2xl:text-sm" 
          placeholder="Inserisci il tuo nome"
        >
        <div>
          <label class="block text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Email</label>
          <input 
            type="email"
            value="giovanni.izzo@leo.com"
            readonly
            class="text-gray-400 w-full p-1 2xl:p-1.5 pl-2 border rounded-md cursor-not-allowed text-xs 2xl:text-sm"
          >
        </div>
      </div>
    </div>
  
    <!-- Country section -->
    <div class="flex flex-col gap-0.5 2xl:gap-1">
      <span class="text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Paese</span> 
      <div class="space-y-2 2xl:space-y-3">
        <select class="w-full p-1 2xl:p-1.5 pl-2 border rounded-md text-xs 2xl:text-sm focus:ring-1 focus:ring-gray-300 focus:border-gray-300">
          <option selected value="IT">Italia</option>
        </select>
  
        <div>
          <div class="flex flex-col gap-0.5 2xl:gap-1">
            <span class="text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Accesso alle regioni</span>
            <div class="relative w-full">
              <button
                type="button"
                (click)="toggleDropdown()"
                class="w-full text-left p-1 2xl:p-1.5 pl-2 border rounded-md text-xs 2xl:text-sm focus:ring-1 focus:ring-gray-300 bg-white" 
              >
                {{ selectedRegions.length === allRegions.length ? 'Tutte le regioni' : selectedRegions.length ? selectedRegions.join(', ') : 'Seleziona regioni' }}
              </button>
  
              <!-- Regions dropdown -->
              <div *ngIf="dropdownOpen" class="absolute z-10 mt-0.5 2xl:mt-1 w-full bg-white border rounded-md shadow-md h-[100px] 2xl:h-[120px] overflow-y-auto text-xs 2xl:text-sm">
                <label class="flex items-center px-2 py-0.5 2xl:py-1 hover:bg-gray-100 cursor-pointer">
                  <input
                    type="checkbox"
                    class="form-checkbox h-3 w-3 mr-2 focus:ring-0 focus:ring-offset-0" 
                    [checked]="areAllSelected()"
                    (change)="toggleAll($event)"
                  >
                  Tutte le regioni
                </label>
  
                <label *ngFor="let region of allRegions" class="flex items-center px-2 py-0.5 2xl:py-1 hover:bg-gray-100 cursor-pointer">
                  <input
                    type="checkbox"
                    class="form-checkbox h-3 w-3 mr-2 focus:ring-0 focus:ring-offset-0" 
                    [checked]="selectedRegions.includes(region)"
                    (change)="toggleRegion(region, $event)"
                  >
                  {{ region }}
                </label>
              </div>
            </div>
          </div>
  
          <!-- Password -->
          <div class="flex flex-col gap-0.5 2xl:gap-1 mt-1.5 2xl:mt-2">
            <label class="block text-xs 2xl:text-sm font-medium text-gray-700 mb-0.5 2xl:mb-1">Password</label>
            <input 
              type="password"
              value=""
              class="w-full p-1 2xl:p-1.5 pl-2 border rounded-md text-xs 2xl:text-sm focus:ring-1 focus:ring-gray-300 focus:border-gray-300" 
            >
          </div>
        </div>
      </div>
    </div>
  
    <!-- Buttons -->
    <div class="relative pt-1.5 2xl:pt-2 mt-4 2xl:mt-6">
      <button type="button" class="cursor-pointer text-white rounded-md bg-green-700 hover:bg-green-800 focus:ring-2 focus:ring-gray-300 text-xs 2xl:text-sm px-3 2xl:px-4 py-1.5 2xl:py-2">Salva</button>
    </div>
  
    <!-- Close button -->
    <button (click)="close()"
      class="cursor-pointer absolute top-1.5 2xl:top-2 right-1.5 2xl:right-2 text-gray-500 hover:text-black transition text-xs 2xl:text-sm focus:ring-0" 
      aria-label="Chiudi"
    >
      ✕
    </button>
  </div>
</div>